import { ComponentPropsWithRef, ReactNode } from "react";
import styled from "styled-components";
import { App, routes as allRoutes } from "@songtradr-sso/shared/common";
import {
  A,
  Body,
  Heading,
  shade800,
  shade850,
} from "@songtradr/design-language";
import { staticText } from "../../../shared/statics/static-text";

// TEXT
export const text = staticText.workspaceCapture.helpPanel;

// STYLES
export const Number = styled(Heading)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  border: 1px solid ${shade850};
  border-radius: 50%;
`;

export const Tip = styled(Body)`
  flex: 1;
`;

export const Info = styled.div`
  display: flex;
  gap: 0.5rem;
  background-color: ${shade850};
  padding: 1rem;

  p {
    flex: 1;
  }
`;

export const NoWorkspace = styled(A)`
  margin-top: 1.5rem;
  text-align: center;
`;

// DATA

// TYPES
export type Props = {
  trigger: ReactNode;
};

// CONSTANTS
export const routes = allRoutes[App.Core];

// FUNCTIONS

// ASSETS
export const LightbulbIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <rect width="100%" height="100%" rx="16" fill={shade800} />
    <path
      d="M13.5999 23.2C13.5999 23.64 13.9599 24 14.3999 24H17.5999C18.0399 24 18.3999 23.64 18.3999 23.2V22.4H13.5999V23.2ZM15.9999 8C12.9119 8 10.3999 10.512 10.3999 13.6C10.3999 15.504 11.3519 17.176 12.7999 18.192V20C12.7999 20.44 13.1599 20.8 13.5999 20.8H18.3999C18.8399 20.8 19.1999 20.44 19.1999 20V18.192C20.6479 17.176 21.5999 15.504 21.5999 13.6C21.5999 10.512 19.0879 8 15.9999 8ZM18.2799 16.88L17.5999 17.36V19.2H14.3999V17.36L13.7199 16.88C13.19 16.5124 12.7569 16.0222 12.4574 15.4511C12.1579 14.8799 12.001 14.2449 11.9999 13.6C11.9999 11.392 13.7919 9.6 15.9999 9.6C18.2079 9.6 19.9999 11.392 19.9999 13.6C19.9999 14.904 19.3599 16.128 18.2799 16.88Z"
      fill="white"
    />
  </svg>
);
